module.exports = __webpack_public_path__ + "img/down-arrow.aafaef8f.png";